import type { CSSProperties, ReactNode } from 'react';

import { Card } from '@actual-app/components/card';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

export function ManagementCard({
  title,
  children,
}: {
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card style={{ margin: 0 }}>
      <View style={{ padding: 18, gap: 12 }}>
        <h2 style={headingStyle}>{title}</h2>
        {children}
      </View>
    </Card>
  );
}

export function Field({
  label,
  htmlFor,
  children,
}: {
  label: ReactNode;
  htmlFor: string;
  children: ReactNode;
}) {
  return (
    <label htmlFor={htmlFor} style={{ display: 'grid', gap: 5 }}>
      <strong>{label}</strong>
      {children}
    </label>
  );
}

export function assertNever(value: never): never {
  throw new Error(`Unsupported financial management value: ${String(value)}`);
}

export const headingStyle: CSSProperties = { margin: 0, fontSize: 20 };

export const formStyle: CSSProperties = {
  display: 'grid',
  gap: 13,
  maxWidth: 560,
};

export const inputStyle: CSSProperties = {
  minHeight: 42,
  padding: '8px 10px',
  border: `1px solid ${theme.formInputBorder}`,
  borderRadius: 4,
  background: theme.formInputBackground,
  color: theme.formInputText,
};

export const helpStyle: CSSProperties = {
  margin: 0,
  color: theme.pageTextSubdued,
  fontSize: 13,
};

export const errorStyle: CSSProperties = { margin: 0, color: theme.errorText };

export const buttonRowStyle: CSSProperties = {
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 8,
};
